import { render, staticRenderFns } from "./closeDetail.vue?vue&type=template&id=9b058aa4&"
import script from "./closeDetail.vue?vue&type=script&lang=js&"
export * from "./closeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports